import styled from 'styled-components';

export const Wrapper = styled.div<{ height: number }>`
  width: 100%;
  height: ${(props) => props.height}px;
  margin-top: 0;
  position: relative;
  z-index: 0;
  border-radius: inherit;
  overflow: hidden;

  .code-preview-wrapper {
    height: 100%;
    display: grid;

    div:first-child {
      height: auto;
    }
  }
`;

export const CopyWrapper = styled.div`
  position: absolute;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-direction: column;
  bottom: 0;
  left: 50%;
  height: 0;
  transform: translate(-50%, 0);
  width: 100%;
`;

export const CopyButtonWrapper = styled.div`
  margin-bottom: 55px;
  display: flex;
  justify-content: center;
`;
